import React, { useState } from "react"
import { decimalAdjust,formatSoles } from "../../Global"
import { BotonAddPequeño, BotonMenosPequeño, BotonRemovePequeño } from "../Plantillas/Botones";

export function SelectedProduct({ 
    menuIsActivated, 
    onToggleMenu, 
    product, 
    onSubtract, 
    onAdd, 
    onRemove,
    onPriceChange,
    onSelectPrice,
    onSecretKeyPress
}) {
    const [showPriceInput, setShowPriceInput] = useState(false);
    const [tempPrice, setTempPrice] = useState(product.PrecioVenta);

    const handlePriceClick = () => {
        setShowPriceInput(true);
        setTempPrice(product.PrecioVenta);
    };

    const handlePriceChange = (e) => {
        const value = e.target.value;
        const newPrice = parseFloat(value) || 0;
        
        // Validate price (must be positive)
        if (newPrice < 0) return;
        
        setTempPrice(newPrice);
        // Update the price immediately for real-time total calculation
        onPriceChange(newPrice);
    };

    const handlePriceBlur = () => {
        setShowPriceInput(false);
        // Ensure the price is properly set when losing focus
        if (tempPrice !== product.PrecioVenta) {
            onPriceChange(tempPrice);
        }
    };

    const handlePriceKeyPress = (e) => {
        if (e.key === 'Enter') {
            setShowPriceInput(false);
            // Ensure the price is set when pressing Enter
            if (tempPrice !== product.PrecioVenta) {
                onPriceChange(tempPrice);
            }
        }
        // Secret key combination (Ctrl+Shift+3) for wholesale price
        if (e.ctrlKey && e.shiftKey && e.key === '3') {
            onSecretKeyPress();
            e.preventDefault();
        }
    };

    // Calculate total based on current state
    const currentTotal = (showPriceInput ? tempPrice : product.PrecioVenta) * product.Cantidad - (product.Descuento || 0);

    // Find the current price option for the select dropdown
    const currentPriceOption = product.precios?.find(p => p.Precio === product.PrecioVenta);
    const currentPriceId = currentPriceOption?.IdPrecioPlantilla || '';

    return (
        <div className="lista-producto-promo-content3">
            <div className="lista-producto-promo3">
                <div className="nombre-prunitario3">
                    <div className="nombre-producto3">{`${product.descripcion} ${product.unidadMedida}`}</div>
                    <div className="detalles-producto3">
                        <p className="cantidad-producto3">{product.Cantidad}</p>
                        
                        {showPriceInput ? (
                            <input
                                type="number"
                                className="precio-input"
                                value={tempPrice}
                                onChange={handlePriceChange}
                                onBlur={handlePriceBlur}
                                onKeyPress={handlePriceKeyPress}
                                autoFocus
                                step="0.01"
                                min="0"
                                placeholder="0.00"
                            />
                        ) : (
                            <p 
                                className="precio-producto3"
                                onClick={handlePriceClick}
                                style={{ cursor: 'pointer' }}
                                title="Click para editar precio"
                            >
                                S/ {formatSoles(product.PrecioVenta)}
                            </p>
                        )}
                        
                        <p className="stock-producto3">
                            S/ {formatSoles(currentTotal)}
                        </p>
                        
                        <button
                            className="btn-toggle-menu"
                            type="button"
                            onClick={(e) => {
                                e.stopPropagation();
                                onToggleMenu();
                            }}
                            title="Opciones"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" width="20" height="20" strokeWidth="2">
                                <path d="M4 6l16 0"></path>
                                <path d="M4 12l16 0"></path>
                                <path d="M4 18l16 0"></path>
                            </svg>
                        </button>

                        {menuIsActivated && (
                            <div className="menu-desplegable" onClick={(e) => e.stopPropagation()}>
                                {product.precios && product.precios.length > 1 && (
                                    <select 
                                        className="price-selector"
                                        onChange={(e) => {
                                            const selectedId = parseInt(e.target.value);
                                            const selectedPrice = product.precios.find(p => p.IdPrecioPlantilla === selectedId);
                                            if (selectedPrice) {
                                                onSelectPrice(selectedPrice.Precio, selectedPrice.NombrePrecio);
                                            }
                                        }}
                                        value={currentPriceId}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        {product.precios.map(price => (
                                            <option key={price.IdPrecioPlantilla} value={price.IdPrecioPlantilla}>
                                                {price.NombrePrecio} (S/ {formatSoles(price.Precio)})
                                            </option>
                                        ))}
                                    </select>
                                )}
                                <BotonMenosPequeño 
                                    type="button" 
                                    title="Disminuir en 1" 
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onSubtract();
                                    }} 
                                />
                                <BotonAddPequeño 
                                    type="button" 
                                    title="Aumentar en 1" 
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onAdd();
                                    }} 
                                />
                                <BotonRemovePequeño 
                                    type="button" 
                                    title="Quitar item" 
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onRemove();
                                    }} 
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export function SelectedProducts({ 
    products, 
    onSubtractQuantity, 
    onAddQuantity, 
    onRemoveProduct,
    onPriceChange,
    onSelectPrice,
    onSecretKeyPress
}) {
    const [activeMenu, setActiveMenu] = useState(null);

    const toggleMenu = (index) => {
        setActiveMenu(activeMenu === index ? null : index);
    };

    const handleClickOutside = () => {
        setActiveMenu(null);
    };

    return (
        <>
            <div className="fijado3">
                <div className="titulo-productos3">
                    <p>CANTIDAD</p>
                    <p></p>
                    <p>PRECIO</p>
                    <p></p>
                    <p>TOTAL</p>
                    <p></p>
                </div>
            </div>
            <div className="productos-promo-scroll3" onClick={handleClickOutside}>
                <div className="lista-producto-promo-general3">
                    {products.map((product, index) => (
                        <SelectedProduct
                            key={`${product.id || index}-${product.descripcion}`}
                            product={product}
                            menuIsActivated={activeMenu === index}
                            onToggleMenu={() => toggleMenu(index)}
                            onSubtract={() => onSubtractQuantity(index)}
                            onAdd={() => onAddQuantity(index)}
                            onRemove={() => onRemoveProduct(index)}
                            onPriceChange={(newPrice) => onPriceChange(index, newPrice)}
                            onSelectPrice={(priceValue, priceName) => onSelectPrice(index, priceValue, priceName)}
                            onSecretKeyPress={() => onSecretKeyPress(index)}
                        />
                    ))}
                </div>
            </div>
        </>
    );
}